<template>
  <v-row v-bind="$attrs">
    <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ text }}</v-alert>
  </v-row>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Грешка!",
    },
  },
};
</script>

<style>
</style>